/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerGetTelegramLinkStatusQueryResponse,
  TelegramUsersControllerGetTelegramLinkStatusPathParams,
  TelegramUsersControllerGetTelegramLinkStatus401,
  TelegramUsersControllerGetTelegramLinkStatus404,
} from '../../types/TelegramUsersControllerGetTelegramLinkStatus.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramUsersGetTelegramLinkStatus } from '../../methods/telegramUsersGetTelegramLinkStatus.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramUsersGetTelegramLinkStatusQueryKey = (
  id: TelegramUsersControllerGetTelegramLinkStatusPathParams['id'],
) => [{ url: '/api/telegram/users/telegram-link/:id', params: { id: id } }] as const;

export type TelegramUsersGetTelegramLinkStatusQueryKey = ReturnType<typeof telegramUsersGetTelegramLinkStatusQueryKey>;

export function telegramUsersGetTelegramLinkStatusQueryOptions(
  id: TelegramUsersControllerGetTelegramLinkStatusPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramUsersGetTelegramLinkStatusQueryKey(id);
  return queryOptions<
    TelegramUsersControllerGetTelegramLinkStatusQueryResponse,
    ResponseErrorConfig<
      TelegramUsersControllerGetTelegramLinkStatus401 | TelegramUsersControllerGetTelegramLinkStatus404
    >,
    TelegramUsersControllerGetTelegramLinkStatusQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramUsersGetTelegramLinkStatus(id, config);
    },
  });
}

/**
 * {@link /api/telegram/users/telegram-link/:id}
 */
export function useTelegramUsersGetTelegramLinkStatus<
  TData = TelegramUsersControllerGetTelegramLinkStatusQueryResponse,
  TQueryData = TelegramUsersControllerGetTelegramLinkStatusQueryResponse,
  TQueryKey extends QueryKey = TelegramUsersGetTelegramLinkStatusQueryKey,
>(
  id: TelegramUsersControllerGetTelegramLinkStatusPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramUsersControllerGetTelegramLinkStatusQueryResponse,
        ResponseErrorConfig<
          TelegramUsersControllerGetTelegramLinkStatus401 | TelegramUsersControllerGetTelegramLinkStatus404
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramUsersGetTelegramLinkStatusQueryKey(id);

  const query = useQuery(
    {
      ...telegramUsersGetTelegramLinkStatusQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      TelegramUsersControllerGetTelegramLinkStatus401 | TelegramUsersControllerGetTelegramLinkStatus404
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
